var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 522,
    height: 517,
    viewBox: "0 0 522 517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9530D",
    d: "M261 0a8.829 8.829 0 0 0-8.828 8.828V35.31h17.655V8.828A8.827 8.827 0 0 0 261 0zM178.5 389.586h163.168v10H178.5z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.193 350.276l-33.886 155.201c-.83 3.802-4.309 6.523-8.338 6.523h-13.267c-3.249 0-5.673-2.882-5.004-5.946l34.012-155.778M332.807 350.276l33.886 155.201c.83 3.802 4.309 6.523 8.338 6.523h13.267c3.248 0 5.673-2.882 5.004-5.946L359.29 350.276"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M508.172 64.895H13.828A8.829 8.829 0 0 1 5 56.067v-8.828a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v8.828a8.83 8.83 0 0 1-8.829 8.828zM13.828 67.966v268.365c0 9.264 7.904 16.773 17.655 16.773h459.034c9.751 0 17.655-7.509 17.655-16.773V67.966"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E9530D",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M234.517 309.138V158.897a8.829 8.829 0 0 1 8.828-8.828h35.31a8.829 8.829 0 0 1 8.828 8.828v150.241M155.069 309.138V203.035a8.829 8.829 0 0 1 8.828-8.828h35.31a8.829 8.829 0 0 1 8.828 8.828v106.103M75.621 309.138v-61.966a8.829 8.829 0 0 1 8.828-8.828h35.31a8.829 8.829 0 0 1 8.828 8.828v61.966H75.621zM313.965 309.138V203.035a8.829 8.829 0 0 1 8.828-8.828h35.31a8.829 8.829 0 0 1 8.828 8.828v106.103M393.414 309.138V105.931a8.829 8.829 0 0 1 8.828-8.828h35.31a8.829 8.829 0 0 1 8.828 8.828v203.207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9530D",
    d: "M458.897 314H62.828a5 5 0 1 1 0-10h396.069a5 5 0 1 1 0 10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLine);
export default __webpack_public_path__ + "static/media/business-line.18177f42ed53fdd5274cf26894752302.svg";
export { ForwardRef as ReactComponent };